import { useCallback, useEffect, useState } from "react";
import "./header.css";
import overlayImg from "../../assets/orchid-storage-detail.jpeg";
import FloatingContactWidget from "../FloatingContactWidget/FloatingContactWidget";
import ContactModal from "../ContactModal/ContactModal";
import BookMeetingModal from "../BookMeetingModal/BookMeetingModal";

const NAV_LINKS = [
  // { to: "/how-we-work", label: "How We Work" },
   
  { to: "/project", label: "Project" },
  { to: "/specialists", label: "Our Specialists" },
  { to: "/ServicePage", label: "Services" },
  // { to: "/furniture-planner", label: "Furniture Planner" },
  { to: "/book-meeting", label: "Book Meeting", action: "meeting" },
  // { to: "/contact", label: "Let's Consult" },
 
];

const PROJECT_SLUGS = [
  "limestone-residence",
  "white-court-house",
  "monochrome-residence",
  "concrete-and-wood",
  "graphite-kitchen",
  "warm-stone-home",
  "atelier-minimal",
  "quiet-geometry",
  "earth-residence",
  "frame-house",
  "shinde-house",
  "stellar-homes",
  "bunglow-interior",
  "riverstone-residence",
  "up-coming-project",
  "upcoming-residential-project",
];

const STUDIO = {
  name: "Dwellora Designs",
  tagline: "Architecture & Interiors",
  address: "Pune, India",
  email: "contact@dwellora.com",
};

const LOGO_IMG =
  "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACsAAAAzCAYAAAAO2PE2AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAJfSURBVHgB7ZiNceIwEIXXN1cAHZw6ODo40gEdxNcBHeCr4OgAUkHuKhCpIEkFdgckFWxWYTdeCQEOsY0842/mjTH6e17JWo0z+AKIOKPLL9KUNWEJFeuJ9OCuWZZV0BfOIOkvaYeXYUk5dAmbtMHAj6SVG5xkSJOgjeF2i0jbsnXTzgBprQZxES1I0092JX3lbFSbnsFXcYZUx2JyAi0QMb2ES6HGt8F0G+gADoCwhs8SGF1Bx9AYc6xf2OaGuaFQQE/wkmtuGPdvb9m3UTW+Nrw4V9lyRQtXAvfbnLzQRpdlqlJOFxf+inTTJNNwZzPST5JhyW7xoiTZawsNoH7v6TInbanNTayCTH9+piO3Vy7R33aa4qK1xjP7Ko8hy2EWFuZcUJ7owKCfHGTwe566Oa85w3K/JXttcL/9acpTgcF6S7NhgcUjUVWR1GcBixdkHX6IFfqz4h7WHBnXjy53IJhI5zoia2wpOaCfwZypRaSO5fJCNzoIN/rbSIlt5O9DM4aXiLCMPFDtjaehdn9o1GJL54ETpouYYfRnfaJDPVcVxOgGekJFMTQsXqbeDfoZbAM9Exi+5f8eP4KpCn9gvTWVXU/9CcOyJHYcPMv3uTar142BK6IM2mNmZTkUcGXQf7F2MbPv0w+JEMz0u9lvQZ07SIeDQ39odgOJQKctd1rb6v+02W2vHyCa8V/faLPPkB7/9I0XWUgMnukXuddmK0iTSn5osztIk2hkk2c02xWj2a4YlNnvUCeDV0gTyawVDIkML/mAex3unFmEYfDbrdk/MAyeYGRkZGRkZJC8AbYdiaAoTIEtAAAAAElFTkSuQmCC";

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [isContactOpen, setIsContactOpen] = useState(false);
  const [isMeetingOpen, setIsMeetingOpen] = useState(false);
  const openContact = useCallback(() => {
    setMenuOpen(false);
    setIsContactOpen(true);
  }, []);
  const closeContact = useCallback(() => setIsContactOpen(false), []);
  const openMeeting = useCallback(() => {
    setMenuOpen(false);
    setIsMeetingOpen(true);
  }, []);
  const closeMeeting = useCallback(() => setIsMeetingOpen(false), []);
  const currentPath =
    typeof window !== "undefined" ? window.location.pathname : "/";
  const cleanPath =
  currentPath.length > 1 ? currentPath.replace(/\/$/, "") : currentPath;
  const hasDarkHero =
    cleanPath === "/" ||
    cleanPath === "/faqs" ||
    // cleanPath === "/how-we-work" ||
    cleanPath === "/project" ||
    cleanPath === "/projects" ||
    cleanPath === "/contact" ||
    cleanPath === "/specialists" ||
    PROJECT_SLUGS.some((slug) => cleanPath === `/${slug}`);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [menuOpen]);

  useEffect(() => {
    window.addEventListener("dwellora:open-contact", openContact);
    return () => window.removeEventListener("dwellora:open-contact", openContact);
  }, [openContact]);

  return (
    <>
      <FloatingContactWidget />
      <header
        className={`site-header-nav ${scrolled ? "site-header-is-stuck" : ""} ${
          hasDarkHero || scrolled ? "" : "site-header-is-solid"
        }`}
      >
        <div className="site-header-wrap site-header-nav-inner">
          <a href="/" className="site-header-logo" aria-label={`${STUDIO.name} — home`}>
            <img
              src={LOGO_IMG}
              alt={`${STUDIO.name} logo`}
              className="site-header-logo-mark-img"
              style={{ width: 38, height: 40 }}
            />
            <span>
              <span className="site-header-logo-word">{STUDIO.name}</span>
            </span>
          </a>

          <nav className="site-header-nav-links" aria-label="Primary">
            {NAV_LINKS.map((link) => (
              <a
                key={link.to}
                href={link.to}
                onClick={(event) => {
                  if (link.action === "meeting") {
                    event.preventDefault();
                    openMeeting();
                  }
                  if (link.to === "/contact") {
                    event.preventDefault();
                    openContact();
                  }
                }}
                className={`site-header-link-u ${
                  currentPath === link.to ||
                  (link.to === "/project" &&
                    (cleanPath === "/projects" ||
                    PROJECT_SLUGS.some((slug) => cleanPath === `/${slug}`))
                  )
                    ? "site-header-is-active"
                    : ""
                }`}
              >
                {link.label}
              </a>
            ))}
            <a
              href="/contact"
              className="site-header-nav-cta"
            >
              <span>Get a Free Quote</span>
            </a>
          </nav>

          <button
            className="site-header-menu-btn"
            onClick={() => setMenuOpen(true)}
            aria-expanded={menuOpen}
            aria-label="Open menu"
          >
            <span>Menu</span>
            <i />
          </button>
        </div>
      </header>

      <div
        className={`site-header-overlay ${menuOpen ? "site-header-is-open" : ""}`}
        role="dialog"
        aria-modal={menuOpen}
        aria-label="Site menu"
      >
        <button
          className="site-header-overlay-close"
          onClick={() => setMenuOpen(false)}
          aria-label="Close menu"
        >
          <span>Close menu</span>
        </button>

        <div className="site-header-overlay-nav">
          {NAV_LINKS.map((link, i) => (
            <a
              key={link.to}
              href={link.to}
              onClick={(event) => {
                if (link.action === "meeting") {
                  event.preventDefault();
                  openMeeting();
                }
                if (link.to === "/contact") {
                  event.preventDefault();
                  openContact();
                }
              }}
              style={{ transitionDelay: `${140 + 70 * i}ms` }}
            >
              <span>{String(i + 1).padStart(2, "0")}</span>
              {link.label}
            </a>
          ))}
          <a
            href="/contact"
            style={{ transitionDelay: "500ms" }}
          >
            <span>{String(NAV_LINKS.length + 1).padStart(2, "0")}</span>
            Get a Free Quote
          </a>
        </div>

        <aside className="site-header-overlay-aside">
          <img
            src={overlayImg}
            // alt="Warm dining room interior"
            loading="lazy"
          />
          {/* <div className="site-header-overlay-meta">
            <p className="site-header-label">Studio</p>
            <p style={{ marginTop: 6 }}>{STUDIO.address}</p>
            <p className="site-header-label" style={{ marginTop: 14 }}>
              {STUDIO.email}
            </p>
          </div> */}
        </aside>
      </div>
      <ContactModal isOpen={isContactOpen} closeModal={closeContact} />
      <BookMeetingModal isOpen={isMeetingOpen} closeModal={closeMeeting} />
    </>
  );
}
